import { fg } from '@atlassian/jira-feature-gating';

// splitting this out from utils.tsx as some functions in utils.tsx import large dependencies, and some storybooks that relied on this function ended up with huge import costs
export const getCreateIssueUrl = ({
	isCreateLinkedIssue = false,
	skipAutoWatch = false,
}: {
	isCreateLinkedIssue?: boolean;
	skipAutoWatch?: boolean;
}): string => {
	const urlSearchParams = new URLSearchParams('updateHistory=true&applyDefaultValues=false');

	if (isCreateLinkedIssue && fg('create_linked_issues_trigger_point_issue_view')) {
		urlSearchParams.append('fromCreateLinkedIssueScreen', 'true');
	}

	if (skipAutoWatch) {
		urlSearchParams.append('skipAutoWatch', 'true');
	}

	return `/rest/api/3/issue?${urlSearchParams.toString()}`;
};
